import * as yup from 'yup';

export const DictionaryEntryValidationSchema = yup.object().shape({
	name: yup
		.string()
		.max(250, 'Maksymalna długość nazwy nie może przekroczyć 250 znaków')
		.required('Nazwa jest wymagana')
});
